import { render, staticRenderFns } from "./StorageUpsell.vue?vue&type=template&id=e763802c&"
import script from "./StorageUpsell.vue?vue&type=script&lang=js&"
export * from "./StorageUpsell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports